(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@element-plus/icons-vue"), require("axios"), require("element-plus"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("AVUE", ["@element-plus/icons-vue", "axios", "element-plus", "vue"], factory);
	else if(typeof exports === 'object')
		exports["AVUE"] = factory(require("@element-plus/icons-vue"), require("axios"), require("element-plus"), require("vue"));
	else
		root["AVUE"] = factory(root["ElementPlusIconsVue"], root["axios"], root["ElementPlus"], root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__element_plus_icons_vue__, __WEBPACK_EXTERNAL_MODULE_axios__, __WEBPACK_EXTERNAL_MODULE_element_plus__, __WEBPACK_EXTERNAL_MODULE_vue__) {
return 